const LiveKeyword = () =>
  import('@/views/main/helper/liveKeyword/LiveKeyword.vue')
export default {
  path: '/main/live/statisticalKeyword',
  name: 'LiveKeyword',
  component: LiveKeyword,
  children: []
}
